import React from 'react';

import { StyledLinearProgress, StyledTypography } from 'styles/common';

import { GOAL_CLOSED_OPTIONS, GOAL_PROGRESS_OPTIONS_MAP } from 'constants/ProjectConstants';

/* Will use Material styles here for better readability */
/* Moving this to separate component 
  1. it is being used at more than two places. 
  2. to incorporate new color logic in this component only.
*/

const CLOSED_GOAL_COLOR_MAP = GOAL_CLOSED_OPTIONS.reduce(
  (accumulator, option) => ({
    ...accumulator,
    [option.value]: option.color,
  }),
  {}
);

const GoalProgressBar = ({ goal, showPercentValue = false, width = '75%' }) => {
  const { goalProgressLevel, goalClosureStatus, getGoalProgress } = goal;

  let barColor = 'primary';

  if (goalProgressLevel !== 'CLOSED') {
    barColor = GOAL_PROGRESS_OPTIONS_MAP[goalProgressLevel]?.color;
  }

  if (goalProgressLevel === 'CLOSED') {
    barColor = CLOSED_GOAL_COLOR_MAP[goalClosureStatus];
  }

  let value = Number(getGoalProgress(0) || 0);

  value = Math.max(value, 0);
  value = Math.min(value, 100);

  return (
    <>
      <StyledLinearProgress
        variant="determinate"
        color="primary"
        barColor={barColor}
        value={value === 0 ? 1 : value}
        width={width}
      />
      {showPercentValue && (
        <StyledTypography display="inline" color={barColor} leftGutter={1} variant="body1">
          {value}%
        </StyledTypography>
      )}
    </>
  );
};

export default GoalProgressBar;
